export class SummaryRequest {
  public status: string = "";
  public sort: string = "";
  public limit: number = 0;
  public offset: number = 0;
}
